import { useCallback } from 'react';
import { isAndroidOS, isIOS } from '../../../../../core/util/device';
import { campaignNames, DOWNLOAD_DRIVER_CLICK_LINK } from '../../../../../core/analytics/events';
import { analyticsTrackEvent } from '../../../../../core/analytics';
import { getNativeStoreDownloadLink } from '../../../../DownloadDriver/util';
import { PWA_ADD_TO_HOME_SCREEN } from '../../../../App/util/tracking';

export const useDownloadApp = (onClose: () => void) => {
  return useCallback(() => {
    if (isIOS() || isAndroidOS()) {
      const campaignName = campaignNames.ACCOUNT_DRAWER;
      analyticsTrackEvent(DOWNLOAD_DRIVER_CLICK_LINK, { campaignName });
      window.location.href = getNativeStoreDownloadLink(campaignName);
      return;
    }

    onClose();
    window.deferredA2HSPrompt && window.deferredA2HSPrompt.prompt();
    analyticsTrackEvent(PWA_ADD_TO_HOME_SCREEN, {
      action: 'solv prompt',
      origin: 'account drawer',
    });
  }, [onClose]);
};
